/* Pop-up guide + −5 % (Pandrum). Voir snippets/pandrum-popup.liquid pour les règles d'affichage. */
(function () {
  var pop = document.getElementById('pd-pop');
  if (!pop || pop.getAttribute('data-pd-initialized') === '1') return;
  pop.setAttribute('data-pd-initialized', '1');

  var teaser = document.getElementById('pd-teaser');
  var dialog = pop.querySelector('.pd-pop__dialog');
  var form = document.getElementById('pd-pop-form');
  var input = document.getElementById('pd-pop-email');
  var submitBtn = form.querySelector('button[type="submit"]');
  var errorEl = form.querySelector('[data-pd-error]');
  var done = pop.querySelector('.pd-pop__step--done');
  var code = pop.getAttribute('data-code');
  var delay = parseInt(pop.getAttribute('data-delay'), 10) || 15000;

  var WEEK = 7 * 24 * 60 * 60 * 1000;
  var K_CLOSED = 'pd_pop_closed_at',
      K_SUB = 'pd_pop_subscribed',
      K_START = 'pd_pop_session_start',
      K_TEASER = 'pd_teaser_hidden_at';

  function store(type) {
    return {
      get: function (k) {
        try { return window[type].getItem(k); }
        catch (e) { return null; }
      },
      set: function (k, v) {
        try { window[type].setItem(k, v); }
        catch (e) {}
      }
    };
  }

  var ls = store('localStorage'), ss = store('sessionStorage');
  var now = Date.now();
  var forced = /[?&]pd_popup=1\b/.test(location.search);
  var posted = !!pop.querySelector('[data-pd-posted]') &&
               location.hash === '#pd-pop-form';
  var subscribed = ls.get(K_SUB) === '1';
  var closedAt = Math.max(
    parseInt(ls.get(K_CLOSED), 10) || 0,
    parseInt(ss.get(K_CLOSED), 10) || 0
  );

  var isOpen = false,
      lastFocus = null,
      cartOpen = false,
      dismissed = false,
      autoShown = false;

  var autoTimer = null,
      closeTimer = null,
      focusTimer = null;

  /* Ne jamais passer par-dessus le panier Upcart ni le tiroir panier du thème. */
  var prevOpened = window.upcartOnCartOpened;
  var prevClosed = window.upcartOnCartClosed;

  window.upcartOnCartOpened = function () {
    cartOpen = true;
    if (isOpen && done.hidden) close(false);
    if (typeof prevOpened === 'function') {
      try { prevOpened.apply(this, arguments); }
      catch (e) {}
    }
  };

  window.upcartOnCartClosed = function () {
    cartOpen = false;
    if (typeof prevClosed === 'function') {
      try { prevClosed.apply(this, arguments); }
      catch (e) {}
    }
  };

  function cartIsOpen() {
    return cartOpen ||
      !!document.querySelector('cart-drawer[open], cart-drawer.active');
  }

  function eligible() {
    if (dismissed || autoShown) return false;
    if (forced) return true;
    if (subscribed || ls.get(K_SUB) === '1') return false;

    closedAt = Math.max(
      closedAt,
      parseInt(ls.get(K_CLOSED), 10) || 0,
      parseInt(ss.get(K_CLOSED), 10) || 0
    );

    return !closedAt || Date.now() - closedAt > WEEK;
  }

  function stopAutomatic() {
    clearTimeout(autoTimer);
    autoTimer = null;
    document.removeEventListener('mouseout', onExitIntent);
  }

  function onExitIntent(e) {
    if (!e.relatedTarget && e.clientY <= 0 &&
        Date.now() - start >= 5000) {
      tryOpen();
    }
  }

  function open(showDone) {
    if (isOpen) return;

    stopAutomatic();
    autoShown = true;
    clearTimeout(closeTimer);
    clearTimeout(focusTimer);

    if (showDone) showSuccess();

    isOpen = true;
    lastFocus = document.activeElement;
    pop.hidden = false;
    if (teaser) teaser.hidden = true;

    document.documentElement.classList.add('pd-pop-lock');
    void pop.offsetWidth;
    pop.classList.add('is-open');

    /* Sur mobile, ne pas ouvrir automatiquement le clavier. */
    focusTimer = setTimeout(function () {
      if (!isOpen) return;

      if (window.matchMedia('(min-width: 750px)').matches &&
          done.hidden) {
        input.focus({ preventScroll: true });
      } else {
        dialog.focus({ preventScroll: true });
      }
    }, 320);
  }

  function close(record) {
    if (!isOpen) return;

    stopAutomatic();
    clearTimeout(focusTimer);
    isOpen = false;

    pop.classList.remove('is-open');
    document.documentElement.classList.remove('pd-pop-lock');

    closeTimer = setTimeout(function () {
      if (!isOpen) pop.hidden = true;
    }, 260);

    if (record !== false) {
      dismissed = true;
      closedAt = Date.now();
      ls.set(K_CLOSED, String(closedAt));
      ss.set(K_CLOSED, String(closedAt));
      showTeaser();
    }

    if (lastFocus && lastFocus.focus) {
      try { lastFocus.focus({ preventScroll: true }); }
      catch (e) {}
    }
  }

  function showTeaser() {
    if (!teaser || subscribed) return;

    var hiddenAt = parseInt(ls.get(K_TEASER), 10) || 0;
    if (hiddenAt && Date.now() - hiddenAt < WEEK) return;

    teaser.hidden = false;
  }

  function showSuccess() {
    subscribed = true;
    ls.set(K_SUB, '1');
    form.hidden = true;
    done.hidden = false;
    if (teaser) teaser.hidden = true;

    var apply = done.querySelector('[data-pd-apply]');
    if (apply) {
      apply.href = '/discount/' + encodeURIComponent(code) +
        '?redirect=' + encodeURIComponent(location.pathname);
    }
  }

  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.hidden = false;
    input.setAttribute('aria-invalid', 'true');
  }

  /* Déclencheurs automatiques. */
  function tryOpen() {
    if (isOpen || !eligible()) return;

    if (cartIsOpen()) {
      autoTimer = setTimeout(tryOpen, 2000);
      return;
    }

    open(false);
  }

  if (posted) {
    open(true);
  } else if (forced) {
    autoTimer = setTimeout(tryOpen, 300);
  } else if (eligible()) {
    var start = parseInt(ss.get(K_START), 10);
    if (!start) {
      start = now;
      ss.set(K_START, String(now));
    }

    autoTimer = setTimeout(
      tryOpen,
      Math.max(0, delay - (now - start))
    );

    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      document.addEventListener('mouseout', onExitIntent);
    }
  } else {
    showTeaser();
  }

  /* Interactions. */
  pop.addEventListener('click', function (e) {
    if (e.target.closest('[data-pd-close]')) close(true);

    var copyBtn = e.target.closest('[data-pd-copy]');
    if (copyBtn) {
      var label = copyBtn.textContent;
      var ok = function () {
        copyBtn.textContent = copyBtn.getAttribute('data-done');
        setTimeout(function () {
          copyBtn.textContent = label;
        }, 1800);
      };

      if (navigator.clipboard) {
        navigator.clipboard.writeText(code).then(ok, ok);
      } else {
        ok();
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') close(true);

    if (e.key === 'Tab') {
      var f = Array.prototype.filter.call(
        dialog.querySelectorAll('a[href], button, input:not([type="hidden"])'),
        function (el) { return el.offsetParent !== null; }
      );

      if (!f.length) return;

      if (e.shiftKey && document.activeElement === f[0]) {
        e.preventDefault();
        f[f.length - 1].focus();
      } else if (!e.shiftKey &&
                 document.activeElement === f[f.length - 1]) {
        e.preventDefault();
        f[0].focus();
      }
    }
  });

  /* La bulle rouvre le pop-up uniquement sur demande du visiteur. */
  if (teaser) {
    teaser.addEventListener('click', function (e) {
      if (e.target.closest('[data-pd-teaser-close]')) {
        teaser.hidden = true;
        ls.set(K_TEASER, String(Date.now()));
        return;
      }

      open(false);
    });
  }

  input.addEventListener('input', function () {
    errorEl.hidden = true;
    input.removeAttribute('aria-invalid');
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    var email = input.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      showError(errorEl.getAttribute('data-invalid'));
      return;
    }

    submitBtn.setAttribute('aria-busy', 'true');

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    })
      .then(function (res) {
        submitBtn.removeAttribute('aria-busy');

        if (res.ok && res.url.indexOf('customer_posted=true') !== -1) {
          showSuccess();
          return;
        }

        /* Vérification anti-robot ou erreur : envoi classique Shopify. */
        form.submit();
      })
      .catch(function () {
        submitBtn.removeAttribute('aria-busy');
        form.submit();
      });
  });
})();